<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '../stores/auth'

const { t } = useI18n()
const authStore = useAuthStore()

const visible = ref(false)
let hideTimer: ReturnType<typeof setTimeout> | null = null

function scheduleHide() {
  if (hideTimer) clearTimeout(hideTimer)
  if (!authStore.isDemo) {
    visible.value = false
    return
  }
  visible.value = true
  hideTimer = setTimeout(() => {
    visible.value = false
  }, 10000)
}

onMounted(scheduleHide)
watch(() => authStore.isDemo, scheduleHide)

onBeforeUnmount(() => {
  if (hideTimer) clearTimeout(hideTimer)
})
</script>

<template>
  <div
    v-if="authStore.isDemo && visible"
    class="bg-red-600 text-white text-center py-2 text-sm font-medium w-full"
  >
    {{ t('demo.banner.text') }}
  </div>
</template>
